import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ServiceEquipmentForm from './ServiceEquipmentForm'

import { storeServiceEquipment } from '../services'
import { handleError } from '../../../helpers'

export default function NewServiceEquipmentModal({ visible, onClose, reload, service }) {
	const [loading, setLoading] = useState(false)
	const { handleSubmit, register, formState: { errors }, reset } = useForm({
		defaultValues: { service_id: service.id }
	})

	const onSubmit = values => {
		setLoading(true)
		storeServiceEquipment(values)
			.then(res => {
				message.success(res.data.message)
				reload()
				reset()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Registrar equipo utilizado</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<ServiceEquipmentForm 
							register={register}
							errors={errors}
							service={service}
						/>
						<Button color='primary' type="submit" disabled={loading}>
							{ loading && <Spinner animation='border' size="sm" className='mr-1' /> }
							Registrar Equipo
						</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}